import React from "react";
import "./footer.css";
import earthmaalogo from "../assets/images/earthmaalogo.webp";
import ContactForm from "./contactform";
import twitter from "../assets/images/twitter-icon.svg";
import youtube from "../assets/images/YouTube-icon.svg";
import facebook from "../assets/images/Facebook-icon.svg";
import linkdin from "../assets/images/LinkedIn-icon.svg";
import instagram from "../assets/images/Instagram-icon.svg";
import pinterest from "../assets/images/Pinterest-icon.svg";


import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer fetchpriority="high"
  decoding="async">
      <div id="FooterMiddleDiv">
        <span className="FooterMiddlespan1">
        <h2>DEMO<sup>®</sup></h2> 
          {/* <img src="" alt="" style={{ width: "150px" }} width={150} height={70}/> */}
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium quia natus pariatur quam doloremque ducimus porro eius repellendus. Earum vero dolore id aperiam, incidunt blanditiis porro harum doloremque unde!
          </p>
          <br />
          <h2>Contact Info</h2>
          <a href="tel:+91 931878*****" class="link">
            +91 931878*****
          </a>
          <a href="test@demo.com" class="link">
            test@demo.com
          </a>
          <br />
      <div style={{display:'flex',alignItems:'center'}}>
  <a href="">
          
                <img src={instagram} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>
          <a href="">
          
                <img src={pinterest} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>
          <a href="">
          
                <img src={youtube} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>
          <a href="">
           
                <img src={linkdin} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>
          <a href=" ">
        
                <img src={facebook} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>
          <a href="">
            
           <img src={twitter} alt="" style={{width:'45px',height:'100%'}} width={30} height={30}/>
          </a>

      </div>
        

        </span>

        <span className="footerlinkes">
          <div>
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About us</Link>
            <Link to="/productlist">Product</Link>
            <Link to="/contact">Contact us</Link>
            <Link to="blog">Blog</Link>
  
           
           
          </div>
        </span>

        <span className="footerlinkes">
          <div>
            <h4>Categories</h4>
            <Link to="/productlist">Man Categorie</Link>
            <Link to="/productlist">Kids Categorie</Link>
            <Link to="/productlist">Categorie</Link>
            <Link to="/productlist">Categorie</Link>
             <Link to="/productlist">Categorie</Link>
           
             <Link to="/productlist">Categorie</Link>
             <Link to="/productlist">Categorie</Link>
          
             <Link to="/productlist">Categorie</Link>
          </div>
        </span>
      </div>


      <br />
      <hr />
      <br />

      <div id="FooterDownDiv">
        <div>
          <a>
            Copyright © 2025 DEMO<sup>®</sup>, All rights reserved.
          </a>
        </div>
        <div id="FooterDown_termsDiv">
          <Link to="/term">Term of use &nbsp;</Link>
         
            <Link to="term">| Return & Refund Policy </Link>
       
       
        </div>
      </div>
    </footer>
  );
};

export default Footer;
